import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage
            src={about}
            w="100%"
            alt="Urban Plant Cafe Restaurant About"
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView>
          <CFImage
            src={about}
            w="100%"
            alt="Urban Plant Cafe Restaurant About"
          />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
